import React, { useRef } from "react";

/**
 * Erkennt horizontales Wischen auf Touch-Geräten. Kurze Bewegungen und
 * vertikales Scrollen werden ignoriert. `onSwipeLeft` wird bei einem Wisch
 * nach links ausgelöst, `onSwipeRight` nach rechts.
 */
export function useHorizontalSwipe(options: {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  enabled?: boolean;
  threshold?: number;
  /** Touch-Event stoppen (verhindert, dass ein äußerer Swipe ebenfalls feuert). */
  stopPropagation?: boolean;
}) {
  const {
    onSwipeLeft,
    onSwipeRight,
    enabled = true,
    threshold = 60,
    stopPropagation = false,
  } = options;
  const start = useRef<{ x: number; y: number } | null>(null);

  const onTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!enabled) return;
    if (stopPropagation) e.stopPropagation();
    const touch = e.touches[0];
    start.current = { x: touch.clientX, y: touch.clientY };
  };

  const onTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!enabled) return;
    if (stopPropagation) e.stopPropagation();
    const started = start.current;
    start.current = null;
    if (!started) return;
    const touch = e.changedTouches[0];
    const dx = touch.clientX - started.x;
    const dy = touch.clientY - started.y;
    if (Math.abs(dx) < threshold) return;
    if (Math.abs(dx) < Math.abs(dy) * 1.2) return;
    if (dx < 0) {
      onSwipeLeft?.();
    } else {
      onSwipeRight?.();
    }
  };

  return { onTouchStart, onTouchEnd };
}
